import React, { useEffect, useRef, useState } from "react";
import { LuFolder, LuFolderOpen } from "react-icons/lu";
import { TbCloudUpload, TbFile, TbTrash } from "react-icons/tb";
import Editor from "@monaco-editor/react";
import { useParams } from "react-router-dom";
import CanvasAnimation from "../../../Components/CanvasItems";
import DeleteFileFolderModal from "./DeleteFileFolderModal";
import Spinner from "../../../Components/Spinner";
import getLanguageFromExtension from "./GetLanguageFromExtension";
import CodeTree from "./CodeTree";



const CodeView = ({ codebase, setCodebase, getCodebase, fetchFileContent, activeTab, setActiveTab, selectedFilePath, setSelectedFilePath, context }) => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id } = useParams();
    const [openFiles, setOpenFiles] = useState([]);
    const [creatingNode, setCreatingNode] = useState({ parentPath: null, type: null });
    const [renamingNode, setRenamingNode] = useState({ path: null, name: "" });
    const [openFolders, setOpenFolders] = useState({});
    const filesToShow = codebase && codebase[activeTab] ? codebase[activeTab] : {};
    const [deletingNode, setDeletingNode] = useState(null)
    const [openDeletingModal, setOpenDeletingModal] = useState(false)
    const [reload, setReaload] = useState(false)
    const newNodeInputRef = useRef(null);
    const renamingInputRef = useRef(null);
    const [loadingSaveFile, setLoadingSaveFile] = useState(false)

    const handleSaveAll = async () => {
        setLoadingSaveFile(true)
        

        try {
            const response = await fetch("https://aiservice.erioon.com/save_changes", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id,
                    project_id,
                    activeTab,
                    // files: changedFiles.map(({ path, filename, content }) => ({ path, filename, content })),
                }),
            });

            if (response.ok) {

              
            } else {
                console.error("Failed to save files", response.status);
            }
        } catch (err) {
            setLoadingSaveFile(false)
        } finally {
            setLoadingSaveFile(false)
        }
    };

    useEffect(() => {
        function hideError(e) {
            if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
                const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
                const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
                if (resizeObserverErr) resizeObserverErr.setAttribute("style", "display: none");
                if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute("style", "display: none");
            }
        }
        window.addEventListener("error", hideError);
        return () => window.removeEventListener("error", hideError);
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (creatingNode.parentPath && newNodeInputRef.current && !newNodeInputRef.current.contains(event.target)) {
                setCreatingNode({ parentPath: null, type: null });
            }
            if (renamingNode.path && renamingInputRef.current && !renamingInputRef.current.contains(event.target)) {
                setRenamingNode({ path: null, name: "" });
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [creatingNode, renamingNode]);

    const handleFileClick = async (path, file) => {
        setSelectedFilePath(path);

        const alreadyOpen = openFiles.find((f) => f.path === path);
        if (alreadyOpen) return;

        const content = await fetchFileContent(path);

        const fileObj = {
            path,
            filename: path.split("/").pop(),
            content,
        };

        setOpenFiles((prev) => [...prev, fileObj]);
    };

    const handleEditorChange = (value) => {
        setOpenFiles((prev) =>
            prev.map((f) => (f.path === selectedFilePath ? { ...f, content: value } : f))
        );
    };

    useEffect(() => {
        if (!selectedFilePath || !codebase) return;

        const refreshFile = async () => {
            try {
                const content = await fetchFileContent(selectedFilePath);

                setOpenFiles((prev) =>
                    prev.map((file) =>
                        file.path === selectedFilePath
                            ? { ...file, content }
                            : file
                    )
                );
            } catch (error) {
                console.error("Error refreshing open file:", error);
            }
        };

        refreshFile();
    }, [codebase, selectedFilePath]);

    const reloadCodebase = () => {
        getCodebase()
        setReaload(true)
        setTimeout(() => {
            setReaload(false)
        }, 2000);
    }

    const selectedFile = openFiles.find((f) => f.path === selectedFilePath);

    return (
        <>
            <div className="main_codespaces_cont_main_body_inner fade-in">
                <div className="sidebar_project_tree">
           

                    <div className="tree_actions">
                         <button className="selected_tree_tab" onClick={() => (reloadCodebase(), setOpenFiles([]))}>
                            <i className={`fa-solid fa-rotate ${reload ? "loading_notification" : ""}`}></i>
                        </button>
                        {loadingSaveFile ? (
                            <button className="tree_actions_btn">
                                <Spinner loading={loadingSaveFile} />
                            </button>
                        ) : (
                            <button className="tree_actions_btn" onClick={handleSaveAll}>
                                Save all <TbCloudUpload />
                            </button>
                        )}
                    </div>

                    {Object.keys(codebase[activeTab] || {}).length > 0 || creatingNode.parentPath ? (
                        <div className="body_tree">
                            <CodeTree
                                treeData={filesToShow}
                                activeTab={activeTab}
                                selectedFilePath={selectedFilePath}
                                setSelectedFilePath={setSelectedFilePath}
                                openFolders={openFolders}
                                setOpenFolders={setOpenFolders}
                                renamingNode={renamingNode}
                                setRenamingNode={setRenamingNode}
                                setDeletingNode={setDeletingNode}
                                setOpenDeletingModal={setOpenDeletingModal}
                                handleFileClick={handleFileClick}
                                setCodebase={setCodebase}
                            />
                        </div>
                    ) : (
                        <div className="body_tree">
                            <div className="body_tree_empty_message_cont">
                                <div className="body_tree_empty_message">
                                    <p className="body_tree_empty_message_title">
                                        No {activeTab} files available yet.
                                    </p>
                                    <p className="body_tree_empty_message_desc">
                                        Once ErioonAI generates your project’s codebase, it will appear here.
                                        You can also start by creating your own files and folders.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                </div>

                <div className="code_body">
                    {selectedFile ? (
                        <>
                            {(/\.(jpg|jpeg|png|gif|webp)$/i.test(selectedFile.filename)) ? (
                                <div className="image_preview_container">
                                    <div
                                        className="image_preview_cont"
                                        style={{
                                            backgroundImage: `url(${selectedFile.content})`,
                                        }}
                                    >
                                    </div>

                                </div>
                            ) : (
                                <Editor
                                    className="code_editor"
                                    language={getLanguageFromExtension(selectedFile.filename)}
                                    value={selectedFile.content}
                                    onChange={handleEditorChange}
                                    theme="vs-light"
                                // options={{ readOnly: true }}
                                />
                            )}
                        </>
                    ) : (
                        <div className="empty_preview_cont">
                            <div className="empty_preview_container">
                                <CanvasAnimation type={"playbox"} />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <DeleteFileFolderModal
                show={openDeletingModal}
                handleClose={() => setOpenDeletingModal(false)}
                fetchRecords={getCodebase}
                message="This action CANNOT be undone. This will permanently delete the item."
                path={deletingNode?.path}
                activeTab={activeTab}
            />
        </>

    )
}

export default CodeView